import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../../themes/themes";
import moment from "moment";
import {
  FilterContainer,
  ButtonViewGraphs,
  ButtonClean,
  ContentFilter,
} from "./ReportSurveyFilters.styled";

const ReportSurveyFilters = ({
  countries,
  lob,
  cities,
  sites,
  handleChangeSelectCountry,
  handleChangeSelectCity,
  handleSetFilters,
  handleChangeDataFilter,
  handleCleanFilters,
  rCities,
  rSites,
}) => {
  const rCountries = useRef();
  const rLob = useRef();
  const rFinalDate = useRef();
  const rInicialDate = useRef();
  const [onStartFilter, setOnStartFilter] = useState(null);
  const [onEndFilter, setOnEndFilter] = useState(null);

  useEffect(() => {
    changeDataFilter();
  }, []);

  let setFilters = () => {
    handleSetFilters();
  };

  let cleanFilters = () => {
    rCities.current.clearValue();
    rSites.current.clearValue();
    rCountries.current.clearValue();
    rLob.current.clearValue();
    setOnStartFilter(null);
    setOnEndFilter(null);
    rInicialDate.current.value = "";
    rFinalDate.current.value = "";

    changeDataFilter(true);

    handleCleanFilters();
  };

  let changeDataFilter = (isClean) => {
    let lobsCurrent = [];
    rLob.current.state.ariaSelection?.value.forEach((element) =>
      lobsCurrent.push(element.value)
    );

    let filter = {
      inicialDate: isClean ? null : onStartFilter,
      finalDate: isClean ? null : onEndFilter,
      site: rSites.current.state.ariaSelection?.value?.value,
      country: rCountries.current.state.ariaSelection?.value?.value,
      city: rCities.current.state.ariaSelection?.value?.value,
      lobs: lobsCurrent,
    };

    handleChangeDataFilter(filter);
  };

  return (
    <FilterContainer>
      <ContentFilter>
        {/* <div>
                    <ClientIcon>
                    </ClientIcon>
                </div>
                <div>
                    <Form.Label style={{ color: themeConfig.primary.icon }}>Client</Form.Label>{' '}    
                    <Select
                        placeholder="Select a client"
                        />
                </div> */}
        <div>
          <Form.Label style={{ color: themeConfig.primary.icon }}>Country</Form.Label>{" "}
          <Select
            placeholder="Select a Country"
            ref={rCountries}
            options={countries}
            onChange={handleChangeSelectCountry}
            onBlur={() => changeDataFilter()}
          />
          <Form.Label style={{ color: themeConfig.primary.icon }}>City</Form.Label>{" "}
          <Select
            placeholder="Select a City"
            ref={rCities}
            options={cities}
            onChange={handleChangeSelectCity}
            onBlur={() => changeDataFilter()}
          />
        </div>
        <div>
          <Form.Label style={{ color: themeConfig.primary.icon }}>Start Date</Form.Label>{" "}
          <Form.Control
            type="date"
            required={false}
            ref={rInicialDate}
            onChange={(e) => {
              if (e.currentTarget.value !== "") {
                setOnStartFilter(
                  moment(e.currentTarget.value).format("YYYY-MM-DD")
                );
              }
            }}
            onBlur={() => changeDataFilter()}
          />
          <Form.Label style={{ color: themeConfig.primary.icon }}>End Date</Form.Label>{" "}
          <Form.Control
            type="date"
            required={false}
            ref={rFinalDate}
            onChange={(e) => {
              if (e.currentTarget.value !== "") {
                setOnEndFilter(
                  moment(e.currentTarget.value).format("YYYY-MM-DD")
                );
              }
            }}
            onBlur={() => changeDataFilter()}
          />
        </div>
        <div>
          <Form.Label style={{ color: themeConfig.primary.icon }}>LOB</Form.Label>{" "}
          <Select
            isMulti
            placeholder="Select a LOB"
            ref={rLob}
            options={lob}
            onBlur={() => changeDataFilter()}
          />
          <Form.Label style={{ color: themeConfig.primary.icon }}>Site</Form.Label>{" "}
          <Select
            placeholder="Select a Site"
            ref={rSites}
            options={sites}
            onBlur={() => changeDataFilter()}
          />
        </div>
        <div>
          <ButtonClean
            style={{ position: "relative", top: "11px", height: "38px" }}
            onClick={() => cleanFilters()}
          >
            Clean
          </ButtonClean>
          <ButtonViewGraphs onClick={() => setFilters()}>
            View Graphs
          </ButtonViewGraphs>
        </div>
      </ContentFilter>
    </FilterContainer>
  );
};

export default ReportSurveyFilters;
